/**
 * Utility for Google Analytics 4 tracking
 */

export const trackStep = (stepName, stepNumber) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', 'quiz_step_view', {
      step_name: stepName,
      step_number: stepNumber,
      page_title: `Quiz Step: ${stepName}`
    });
    // console.log(`[GA4] Tracked step: ${stepName} (${stepNumber})`);
  }
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
    // console.log(`[GA4] Tracked event: ${eventName}`, params);
  }
};
